import React from 'react';
import './tcp-header.scss';
import { Link } from 'react-router-dom';
import Button, { ButtonTypes } from '../../../../components/views/button';
import RouteUrls from '../../../../constants/route-urls';

const TcpHeader = () => (
  <div className="tcp-header-cont">
    <div className="tcp-header-logo" />
    <div className="tcp-header-buttons">
      <Link to={RouteUrls.signIn}><Button label="SIGN_IN" type={ButtonTypes.LINK} /></Link>
      <Link to={RouteUrls.signIn}><Button label="SIGN_UP" type={ButtonTypes.PRIMARY} /></Link>
    </div>
  </div>
);

TcpHeader.propTypes = {};

TcpHeader.defaultProps = {};

export default TcpHeader;
